import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import ContractManagement from "./contractManagement";
import Button from "../../../component/button";
import Breadcrumb from "../../../component/breadcrumb";
import { withTranslation } from "react-i18next";
import { withNavigation } from "../../../helper/withNavigation";

class ProviderContracts extends Component {
  state = {
    bread: [{ title: this.props.t("MY_CONTRACTS"), url: "/contracts" }],
  };
  componentDidMount() {
    this.props.setErrorMessage();
  }
  addContract = () => {
    this.contractManagement.openContractModal();
  };
  changeRoute = (id) => {
    this.props.router.navigate("/contract/" + id);
  };
  render() {
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {this.props.userPerms.includes("CUMULATOR-CONTRACT_CREATE") && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Button onClick={() => this.addContract()}>
                    {this.props.t("ADD_CONTRACT")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative" }}>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <ContractManagement
                userPerms={this.props.userPerms}
                onRef={(ref) => (this.contractManagement = ref)}
                changeRoute={this.changeRoute}
              />
            </Grid>
          </Grid>
        </main>
      </div>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    userPerms: state.auth.userPerms,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ProviderContracts)));
